import React from "react";
import { Subheader } from "../../text";

export function Validation(props) {
  return (
    <Subheader
      color={props.color ? props.color : "error"}
      mb={props.mb}
      mt={props.mt}
    >
      {props.children}
    </Subheader>
  );
}
